<div class="layout-row align-end gap-2px responsive-column container m-b-20">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_ADHOC'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
  <button mat-raised-button color="warn" (click)="deleteAdhocQuery()" *LOSxHasPermission="'DELETE_ADHOC'">
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.name' | translate }}
        </div>

        <div class="flex-50">
          {{ adhocQueryData.name }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Query' | translate }}
        </div>

        <div class="flex-50">
          {{ adhocQueryData.query }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Table Affected' | translate }}
        </div>

        <div class="flex-50">
          {{ adhocQueryData.tableName }}
        </div>

        @if (adhocQueryData.reportRunFrequency) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Report Run Frequency' | translate }}
          </div>
        }

        @if (adhocQueryData.reportRunFrequency) {
          <div class="flex-50">
            {{ reportRunFrequency }}
          </div>
        }

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Status' | translate }}
        </div>

        <div class="flex-50">
          {{ adhocQueryData.isActive === true ? 'Active' : 'Inactive' }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Created By' | translate }}
        </div>

        <div class="flex-50">
          {{ adhocQueryData.createdBy }}
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
